/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAttachmentDownloadUrlQueryVariables = Types.Exact<{
  fileID: Types.Scalars['ID']['input']
}>

export type GetAttachmentDownloadUrlQuery = {
  __typename?: 'Query'
  patientFile: {
    __typename?: 'PatientFile'
    fileID: string
    filename: string
    contentType: string
    downloadURL?: string | null
  }
}

export const GetAttachmentDownloadUrlDocument = gql`
  query getAttachmentDownloadUrl($fileID: ID!) {
    patientFile(fileID: $fileID) {
      fileID
      filename
      contentType
      downloadURL
    }
  }
`

/**
 * __useGetAttachmentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetAttachmentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentDownloadUrlQuery({
 *   variables: {
 *      fileID: // value for 'fileID'
 *   },
 * });
 */
export function useGetAttachmentDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<GetAttachmentDownloadUrlQuery, GetAttachmentDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAttachmentDownloadUrlQuery, GetAttachmentDownloadUrlQueryVariables>(
    GetAttachmentDownloadUrlDocument,
    options
  )
}
export function useGetAttachmentDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentDownloadUrlQuery, GetAttachmentDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAttachmentDownloadUrlQuery, GetAttachmentDownloadUrlQueryVariables>(
    GetAttachmentDownloadUrlDocument,
    options
  )
}
export type GetAttachmentDownloadUrlQueryHookResult = ReturnType<typeof useGetAttachmentDownloadUrlQuery>
export type GetAttachmentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetAttachmentDownloadUrlLazyQuery>
export type GetAttachmentDownloadUrlQueryResult = Apollo.QueryResult<
  GetAttachmentDownloadUrlQuery,
  GetAttachmentDownloadUrlQueryVariables
>
